<button
  mat-menu-item
  [disabled]="isDisabled$ | async"
  (click)="deletePatient()"
>
  <mat-icon class="warn">delete</mat-icon>
  <span class="warn">Delete Patient</span>
</button>
